/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-filename-extension */
import { Fragment, h } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { useScrollDirection, ScrollDirection } from '@utils/useScrollDirection'

import MegaMenu from '@features/navbar/MegaMenu'
import HeaderLinks from '../HeaderLinks'
import VatPicker from '../VatPicker'
import InfralogicLogo from '@components/logo/InfralogicLogo'
import useSSR from '@core/hooks/useSSR'
import modelTypes from '@constants/modelTypes'

export default function Navbar({
	navbarClassName,
	headerLinks,
	menu,
	vat,
	logo,
	isDesktop,
	LanguagePickerComponent,
	MenuComponent,
	motivators,
	search,
	SearchComponent,
	cartQuantity,
	wishlistQuantity,
	showSearchAsIcon = false,
	showMenuAsIcon = false,
	menuText = '',
	flyoutNavbar = false,
	stickyHeaderScrollThreshold,
	customerLinks = {},
}) {
	/* lifecycle */
	const [stuck, setStuck] = useState(false)
	const scrollDirection = useScrollDirection(stickyHeaderScrollThreshold)
	const { isAuthenticated } = headerLinks
	const { routes, footer } = useSSR([modelTypes.routes, modelTypes.footer])
	const { storePhone } = footer
	const phoneTextDesktop = window.INITIAL_RESOURCES['navbar.call.desktop']

	useEffect(() => {
		setStuck(scrollDirection !== ScrollDirection.Up)
	}, [scrollDirection])

	return (
		<header className={`${navbarClassName || 'wui-nav'} ${stuck ? '--stuck' : ''}`}>
			{isDesktop && vat && (
				<div className="topbar">
					<div className="inner">
						{vat && <VatPicker vats={vat} />}

						{isAuthenticated ? (
							<div className="topbar-auth">
								<a href={routes.customer.info}>Mina sidor</a>
								<a href={routes.customer.logout}>Logga ut</a>
							</div>
						) : (
							<div className="topbar-auth">
								<a href={routes.customer.login}>Logga in</a>
								<a href={routes.customer.register}>Bli kund</a>
							</div>
						)}
					</div>
				</div>
			)}

			{(logo || headerLinks || menu || MenuComponent || search || SearchComponent) && (
				<section className="nav-main">
					{showMenuAsIcon && isDesktop ? (
						<div className="nav-main__left">
							<div className="site-logo" id="site-logo">
								<InfralogicLogo height={62} />
							</div>

							{menuText && (
								<div className="flex align-center justify-center ml-5" data-drawer-toggle="menu">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M3 17H21C21.5523 17 22 17.4477 22 18C22 18.5128 21.614 18.9355 21.1166 18.9933L21 19H3C2.44772 19 2 18.5523 2 18C2 17.4872 2.38604 17.0645 2.88338 17.0067L3 17H21H3ZM2.99988 11L20.9999 10.9978C21.5522 10.9978 22 11.4454 22 11.9977C22 12.5106 21.6141 12.9333 21.1167 12.9911L21.0001 12.9978L3.00012 13C2.44784 13.0001 2 12.5524 2 12.0001C2 11.4873 2.38594 11.0646 2.88326 11.0067L2.99988 11L20.9999 10.9978L2.99988 11ZM3 5H21C21.5523 5 22 5.44772 22 6C22 6.51284 21.614 6.93551 21.1166 6.99327L21 7H3C2.44772 7 2 6.55228 2 6C2 5.48716 2.38604 5.06449 2.88338 5.00673L3 5H21H3Z"
											fill="#223344"
										/>
									</svg>
									<span className="ml-4">{menuText}</span>
								</div>
							)}
						</div>
					) : (
						<a href="/" className="site-logo" id="site-logo">
							<InfralogicLogo height={54} />
						</a>
					)}

					{showSearchAsIcon && (
						<div
							id="modal-quicksearch"
							className="modal hidden fade-out-top"
							data-drawer-name="search"
							data-animate-in="fade-in-top"
							data-animate-out="fade-out-top"
							data-title="Sök"
						/>
					)}

					{isDesktop ? (
						<div className="nav-main__center">
							{!showSearchAsIcon && SearchComponent && (
								<div
									className="quicksearch-wrapper"
									style={{ position: 'relative', zIndex: 1000000000000 }}
								>
									{SearchComponent}
								</div>
							)}

							<div className="nav-main-phone">
								<div className="nav-main-phone__icon">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										height={24}
										viewBox="0 -960 960 960"
										width={24}
									>
										<path d="M777.614-140.001q-113.076 0-227.191-52.577-114.115-52.577-209.691-148.346-95.577-95.769-148.154-209.691-52.577-113.923-52.577-226.999 0-18.165 12-30.275t30-12.11h130.46q15.154 0 26.731 9.885 11.577 9.885 14.73 24.423L376.845-668q2.385 16.385-1 28.154-3.384 11.769-12.154 19.769l-92.384 89.923q22.308 40.846 50.962 77.269 28.654 36.424 62.038 69.578 32.924 32.923 70.001 61.154 37.077 28.231 80.077 52.538l89.769-90.538q9.385-9.769 22.731-13.692 13.346-3.923 27.731-1.923l111.075 22.615q15.154 4 24.731 15.461 9.577 11.462 9.577 26.001v129.69q0 18-12.11 30t-30.275 12ZM242.923-586.922l71.385-68.308q1.923-1.539 2.5-4.231.577-2.693-.192-5l-17.385-89.385q-.769-3.077-2.692-4.615-1.923-1.539-5-1.539H206q-2.307 0-3.846 1.539-1.539 1.538-1.539 3.846 3.077 41 13.423 83.308 10.347 42.308 28.885 84.385Zm347.999 345.691q39.77 18.539 82.962 28.347 43.193 9.807 80.731 11.653 2.308 0 3.846-1.538 1.539-1.539 1.539-3.847v-84.153q0-3.077-1.539-5.001-1.538-1.923-4.615-2.692l-84-17.077q-2.307-.769-4.038-.192-1.731.577-3.654 2.5l-71.232 72ZM242.923-586.922Zm347.999 345.691Z" />
									</svg>
								</div>

								<a href={`tel:${storePhone}`} className="nav-main-phone__content">
									<span className="nav-main-phone__title">{phoneTextDesktop}</span>
									<span className="nav-main-phone__number">{storePhone}</span>
								</a>
							</div>
						</div>
					) : (
						<>
							{!showSearchAsIcon && SearchComponent && (
								<div
									className="quicksearch-wrapper"
									style={{ position: 'relative', zIndex: 1000000000000 }}
								>
									{SearchComponent}
								</div>
							)}
						</>
					)}

					<HeaderLinks
						headerLinks={headerLinks}
						wishlistQuantity={wishlistQuantity}
						cartQuantity={cartQuantity}
						showSearchIcon={showSearchAsIcon}
						showMenuIcon={showMenuAsIcon}
						search={search}
						SearchComponent={SearchComponent}
						customerLinks={customerLinks}
						storePhone={storePhone}
					/>

					{!isDesktop && (
						<div
							id="modal-menu"
							data-drawer-name="menu"
							data-animate-in="fade-in"
							data-animate-out="fade-out"
							data-title="Main Menu"
							className="hidden"
						/>
					)}
				</section>
			)}

			{isDesktop && <MegaMenu isAuthenticated={isAuthenticated} routes={routes} />}
		</header>
	)
}
